import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(value: string): string {
    return DurationPipe.transformDuration(value);
  }

  static transformDuration(value: string): string {
    if (!value || !value.endsWith('s')) {
      return 'Invalid duration';
    }
    const seconds = parseInt(value.slice(0, -1), 10);
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minutes`;
  }
}

@Pipe({
  name: 'isSelected',
  standalone: true,
})
export class IsSelectedPipe implements PipeTransform {
  transform(meetingId: string, selectedId: string): boolean {
    return meetingId === selectedId;
  }
}
